import type { RouteRecordRaw } from 'vue-router'

const TextToAudio = () => import('@/views/textToAudio/TextToAudio.vue')
const ConversionRecords = () => import('@/views/conversion/ConversionRecords.vue')
const BatchProcess = () => import('@/views/batch/BatchTaskPageNew.vue')
const Library = () => import('@/views/Library.vue')
const Documents = () => import('@/views/Documents.vue')
const Settings = () => import('@/views/Settings.vue')
const PaymentResult = () => import('@/views/PaymentResult.vue')
const ReferralCenter = () => import('@/views/referral/ReferralCenter.vue')
const ReferralLanding = () => import('@/views/referral/ReferralLanding.vue')
const ReferralDashboard = () => import('@/views/referral/ReferralDashboard.vue')
const ShortDramaDubbing = () => import('@/views/dubbing/ShortDramaDubbing.vue')

export const appRoutes: RouteRecordRaw[] = [
  {
    path: '/app',
    name: 'main',
    component: TextToAudio,
    meta: {
      title: '工作台',
      icon: 'Microphone',
      keepAlive: true,
      showIcp: true
    }
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: ConversionRecords,
    meta: {
      title: '转换记录',
      icon: 'List',
      keepAlive: true,
      showIcp: false
    }
  },
  {
    path: '/batch',
    name: 'batch',
    component: BatchProcess,
    meta: {
      title: '批量转换',
      icon: 'Files',
      requiresAuth: true,
      keepAlive: true,
      showIcp: false
    }
  },
  {
    path: '/dubbing',
    name: 'dubbing',
    component: ShortDramaDubbing,
    meta: {
      title: '短剧配音工作台',
      icon: 'VideoCamera',
      requiresAuth: true,
      keepAlive: true,
      showIcp: false
    }
  },
  {
    path: '/library',
    name: 'library',
    component: Library,
    meta: {
      title: '资产库',
      icon: 'FolderOpened',
      requiresAuth: true,
      keepAlive: true,
      showIcp: false
    }
  },
  {
    path: '/referral',
    component: ReferralCenter,
    meta: {
      title: '推广中心',
      icon: 'Promotion',
      showIcp: false,
      seo: {
        description: '推广中心，了解邀请奖励规则与收益说明。',
        canonical: '/referral'
      }
    },
    children: [
      {
        path: '',
        name: 'referral-landing',
        component: ReferralLanding,
        meta: {
          title: '推广中心 - 落地页',
          seo: {
            description: '邀请好友使用小影配音，获得推广奖励。',
            canonical: '/referral'
          }
        }
      },
      {
        path: 'dashboard',
        name: 'referral-dashboard',
        component: ReferralDashboard,
        meta: {
          title: '推广中心 - 数据中心',
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/docs',
    name: 'docs',
    component: Documents,
    meta: {
      title: '文档',
      icon: 'Document',
      keepAlive: true,
      showIcp: false,
      seo: {
        description: '小影配音使用文档，包含功能说明与常见问题。',
        canonical: '/docs'
      }
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      title: '系统设置',
      icon: 'Setting',
      requiresAuth: true,
      keepAlive: true,
      showIcp: false
    }
  },
  {
    path: '/payment/result',
    name: 'PaymentResult',
    component: PaymentResult,
    meta: {
      title: '支付结果',
      icon: 'CreditCard',
      requiresAuth: true,
      hideInMenu: true,
      showIcp: false
    }
  },
  {
    path: '/auth/login',
    redirect: '/app'
  },
  {
    path: '/auth/register',
    redirect: '/app'
  },
  {
    path: '/',
    name: 'landing',
    component: () => import('@/views/landing/LandingPage.vue'),
    meta: {
      title: '首页',
      hideInMenu: true,
      showIcp: false,
      requiresAuth: false,
      seo: {
        description: 'AI智能配音平台，支持文字转语音、批量配音与多场景创作。',
        keywords: 'AI配音,文字转语音,在线配音,TTS',
        canonical: '/'
      }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: '页面未找到',
      hideInMenu: true,
      showIcp: false
    }
  }
]
